import { useState } from 'react';
import SimpleSearch from '../../core/SimpleSearch';
import adminSchoolsService from '../../../services/api/admin.schools.service';
import AdminSchoolsSearchResults from '../../../containers/admin/tabs/organizations/schools/AdminSchoolsSearchResults';

const AdminContactSearchSchool = ({ onSelect }) => {
  const [query, setQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleClear = () => {
    setQuery('');
    setSearchResults([]);
    setShowResults(false);
  };

  const handleSearch = () => {
    setIsSearching(true);
    adminSchoolsService.search(query, {
      onError: () => {},
      onSuccess: (results) => {
        setSearchResults(results);
        setShowResults(true);
        setIsSearching(false);
      }
    });
  };

  const handleResultSelect = (selected) => {
    const parentIds = selected?.spoEntityData?.agodi?.treePath?.split('#')?.filter((id) => !!id);
    if (parentIds?.length === 0) {
      onSelect({ netId: selected.id });
    }
    if (parentIds?.length === 1) {
      onSelect({ netId: parentIds[0], managementId: selected.id });
    }
    if (parentIds?.length === 2) {
      onSelect({ netId: parentIds[0], managementId: parentIds[1], communityId: selected.id });
    }
    if (parentIds?.length === 3) {
      onSelect({ netId: parentIds[0], managementId: parentIds[1], communityId: parentIds[2], schoolId: selected.id });
    }
    setShowResults(false);
  };

  return (
    <div className="spo-o-admin-contact-search-school">
      <SimpleSearch
        className="u-margin-bottom"
        query={query}
        canSearch={query?.length > 2}
        onClear={handleClear}
        onSearch={handleSearch}
        onChange={setQuery}
        description="Voer minimaal 3 tekens in om te zoeken"
      />
      <AdminSchoolsSearchResults
        results={searchResults}
        isLoading={isSearching}
        onResultSelect={handleResultSelect}
        showResults={showResults}
        compact
      />
    </div>
  );
};

export default AdminContactSearchSchool;
